import { useStore } from 'effector-react'
import { carVehicleCategoryModel } from '~/widgets/CarVehicleCategoryDrawer'
import { documentsModel } from '~/widgets/Documents'
import { useMainTaxipark } from '~/widgets/MainTaxipark'
// import { localNotificationsModel } from '~/widgets/Notifications'
import { penaltiesModel } from '~/widgets/Penalties'
import { profileModel } from '~/widgets/Profile'
import { supportModel } from '~/widgets/Support'
import { driverModel } from '~/entities/Driver'
import { rentalContractModel } from '~/entities/RentalContract'
import { viewerModel } from '~/entities/viewer'
import { canShowObject } from '~/shared/lib/utils'
import {
  MenuTouchIDIcon,
  // MenuNotificationsIcon,
  MenuCameraIcon,
  // MenuFireIcon,
  MenuQuestionIcon,
  // MenuPresentIcon,
  MenuLogoutIcon,
  MenuAppRegistrationIcon,
  DocumentsIcon,
  MenuCarIcon,
  InspectionsIcon,
  MenuWorkScheduleIcon,
  MenuFuelIcon,
} from '~/shared/ui/icons'

import { MenuType } from '../type'

export const useMenu = (): MenuType[] => {
  const mainTaxiparks = useMainTaxipark()
  const hasOnlineRental = mainTaxiparks?.hasOnlineRental
  const isInspectionsVisible = mainTaxiparks?.isInspectionsVisible
  const rentalContract = useStore(rentalContractModel.$rentalContract)
  const driver = useStore(driverModel.$driver)
  const availableFuelRefill = driver?.getAvailableFuelRefill() ?? false

  return [
    ...canShowObject(Boolean(hasOnlineRental), {
      title: 'Каталог авто',
      icon: <MenuCarIcon />,
      fn: carVehicleCategoryModel.openCarVehicleCategoryDrawer,
    }),
    {
      title: 'Личные данные',
      icon: <MenuTouchIDIcon />,
      fn: profileModel.openProfileDrawer,
    },
    // {
    //   title: 'Уведомления',
    //   icon: <MenuNotificationsIcon />,
    //   fn: localNotificationsModel.openNotificationsDrawer,
    //   notification: true,
    // },
    {
      title: 'Штрафы',
      icon: <MenuCameraIcon />,
      fn: penaltiesModel.openPenaltiesDrawer,
      notification: true,
    },
    ...canShowObject(availableFuelRefill, {
      title: 'Заправка',
      icon: <MenuFuelIcon />,
      to: '/refueling',
    }),
    ...canShowObject(Boolean(rentalContract), {
      title: 'График списаний',
      icon: <MenuWorkScheduleIcon />,
      to: '/work-schedule',
    }),
    // {
    //   title: 'Программа лояльности',
    //   icon: <MenuPresentIcon />,
    //   to: '/',
    //   disabled: true,
    // },
    // {
    //   title: 'Частые вопросы',
    //   icon: <MenuFireIcon />,
    //   to: '/',
    //   disabled: true,
    // },
    {
      title: 'Поддержка',
      icon: <MenuQuestionIcon />,
      fn: supportModel.openSupportDrawer,
    },
    {
      title: 'Документы',
      icon: <DocumentsIcon />,
      fn: documentsModel.openDocumentsDrawer,
    },
    ...canShowObject(Boolean(isInspectionsVisible), {
      title: 'Осмотры',
      icon: <InspectionsIcon />,
      to: '/inspections',
    }),
    {
      title: 'Запись на осмотр',
      icon: <MenuAppRegistrationIcon />,
      href: 'https://инфо369.рф/select',
    },
    {
      title: 'Выйти',
      icon: <MenuLogoutIcon />,
      fn: viewerModel.signOut,
    },
  ]
}
